export class ProductCategoryInfo {
    productCategoryID: string;
    productCategory: string;
    productCategoryName: string;
    // organizationIdName:string;

    constructor() {
        //this.organizationIdName = 'DataLabsIndia';
        this.productCategoryID = null;
        this.productCategory = null;
        this.productCategoryName = null;
    }
}
export class columnInfo {
    _id: string;
    columnName: string;

    constructor() {
        this._id = null;
        this.columnName = null;
    }
}